export default [
  {text: '#1A73E8', bg: '#f0f6fe'},
  {text: '#D93025', bg: '#fdf2f1'},
  {text: '#188038', bg: '#f0f7f2'},
  {text: '#F9AB00', bg: '#fffaee'},
  {text: '#5F6368', bg: '#f5f5f5'},
  {text: '#8E24AA', bg: '#f8f1f9'},
  {text: '#0D47A1', bg: '#e3eaf4'},
];